import { gql } from '@apollo/client';

const Fragments = {

    accountStatementItem: gql`
    fragment accountStatementItem on AccountStatementItem {
        configId
        configName
        configVersion
        activeYN
        usedByPartner
        bankId
        bankPartnerName
    }
    `,
    accountStatementDetailItem: gql` 
    fragment accountStatementDetailItem on AccountStatementDetailItem {
        configDetailId
        accountSymbol
        accountName
        accountTypeId
        accountTypeName
        accountClass
        financialIndicatorId
        financialIndicatorName
        attributName
        orderNo
        visibleYN
        readOnlyYN
    }
  `,

accountStatementIndicatorItem: gql` 
fragment accountStatementIndicatorItem on AccountStatementIndicatorItem {
    statementIndicatorId
    configId
    code
    name
    attributeName
    expression
    financialIndicatorId
    orderNo
    computeOrder
    readOnlyYN
    visibleYN
}
`,

}

export default Fragments;